export const state = () => ({
	searchFilter: null,
	dateFilter: null,
	itemSort: {
		item: null,
		order: null,
	},
	customFilters: {},
	selected: [],
});

export const mutations = {
	setSearchFilter(state, payload) {
		state.searchFilter = payload;
	},
	setDateFilter(state, payload) {
		state.dateFilter = payload;
	},
	setItemSort(state, payload) {
		state.itemSort = payload;
	},
	setCustomFilters(state, payload) {
		state.customFilters = Object.assign({}, payload);
	},
	setRowsSelected(state, payload) {
		const index = state.selected.indexOf(payload);
		if (index === -1) {
			state.selected.push(payload);
		} else {
			state.selected.splice(index, 1);
		}
	},
	clearRowsSelected(state) {
		state.selected = [];
	},
	clearFilters(state) {
		state.searchFilter = null;
		state.dateFilter = null;
		state.itemSort = {
			item: null,
			order: null,
		};
		state.customFilters = {};
		state.selected = [];
	},
};

export const getters = {
	getSearchFilter: (state) => state.searchFilter,
	getDateFilter: (state) => state.dateFilter,
	getItemSort: (state) => state.itemSort,
	getCustomFilters: (state) => state.customFilters,
	getRowsSelected: (state) => state.selected,
};
